import React from 'react';
import { Link } from 'react-router-dom';
import Types from '../../modules/types';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';
 // eslint-disable-next-line max-len
import { getLinkWithSearchFields, getSubjectUrl, StoreLink } from '../../components/Links';
 // eslint-disable-next-line max-len
import { columnCreatedAt, columnUpdatedAt } from '../../components/common';
import Popover from '../../components/Popover';
 // eslint-disable-next-line max-len
export const columnStoreId = { path: 'storeId', title: 'Store ID', link: '/stores/:store._id' };
 // eslint-disable-next-line max-len
export const orderLength = { path: 'store.orders', title: 'Orders', sort: 'orders' };
export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };
export const soa = { title: 'SOA' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };

export const columnActive = {
  path: 'active',
  title: 'Status',
  render: record => (record.active ? 'ACTIVE' : 'INACTIVE'),
};

function StoreLinkForPayouts({
  location,
  subject,
  filterName = 'store',
  searchLabel = 'store',
  children,
  style,
}) {
  if (!subject) {
    return 'N / A';
  }
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show orders with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{ name: filterName, value: subject._id }],
              { pathname: '/payout/merchant' },
            )}
          >
            {`this ${searchLabel}`}
          </Link>
        </div>
      )}
    >
      <Link style={style} to={getSubjectUrl('/stores', subject)}>
        {
          children
          ? children
          : `${subject.name}`
        }
      </Link>
    </Popover>
  );
}

export const columnStore = {
  path: 'store',
  title: 'Store Name',
  render: (record, column, props) => (
    record.store
      ? (
        // <StoreLinkForPayouts
        //   location={props.location}
        //   subject={record.store}
        //   pathname={getRoleBasedPath(props, '/orders')}
        // />
        record.store.name
      )
      : 'N/A'
  ),
};

export const ADMIN = [
  columnStoreId,
  columnStore,
  orderLength,
  blanace,
  // soa,
  // columnCreatedAt,
  // columnUpdatedAt,
];

export const SELLER = [
  columnStoreId,
  columnStore,
  orderLength,
  blanace,
  // columnCreatedAt,
  // columnUpdatedAt,
];
